import {authStore} from '@/composables/store-accessor'
export default defineNuxtRouteMiddleware(() => {
    if (![1, 2].includes(authStore.person.referralLevel)) {
        return navigateTo('/')
    }
})
